<template>
  <div>
    <ToolbarAuth />
    <Navigation />
    <div class="mt-15 ml-15 mr-15">
      <v-card>
        <v-card-title class="primary--text">DETAILS</v-card-title>
        <v-simple-table>
          <template v-slot:default>
            <thead></thead>
            <tbody>
              <tr>
                <td class="text-h5 accent--text">Nederlands</td>
                <td></td>
              </tr>
              <tr>
                <td>{{ $t("crud.ref") }}</td>
                <td>{{ dataext.reference }}</td>
              </tr>
              <tr>
                <td>Stelling</td>
                <td>{{ dataext.statement }}</td>
              </tr>
              <tr>
                <td>Toelichting Ja/Nee</td>
                <td>
                  <v-icon class="accent--text" v-show="dataext.comment"
                    >mdi-check</v-icon
                  >
                  <v-icon class="primary--text" v-show="!dataext.comment"
                    >mdi-minus-box</v-icon
                  >
                </td>
              </tr>
              <tr>
                <td>Toelichting</td>
                <td>{{ dataext.note }}</td>
              </tr>
              <tr>
                <td class="text-h5 accent--text">English</td>
                <td></td>
              </tr>
              <tr>
                <td>Theorem</td>
                <td>{{ dataext.statement_en }}</td>
              </tr>
              <tr>
                <td>Comment Y/N</td>
                <td>
                  <v-icon class="accent--text" v-show="dataext.comment_en"
                    >mdi-check</v-icon
                  >
                  <v-icon class="primary--text" v-show="!dataext.comment_en"
                    >mdi-minus-box</v-icon
                  >
                </td>
              </tr>
              <tr>
                <td>Note</td>
                <td>{{ dataext.note_en }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="closeView()" large class="ma-5" color="accent">
            {{ $t("crud.close") }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </div>
  </div>
</template>

<script>
import ToolbarAuth from "@/components/navigation/ToolbarAuth";
import Navigation from "@/components/navigation/Navigation";
import CmainService from "@/services/fsmain/CmainService";

export default {
  name: "cmainview",
  components: { ToolbarAuth, Navigation },
  data() {
    return {
      dataext: {},
    };
  },
  methods: {
    getData() {
      let id = this.$route.params.id;
      this.loading = true;
      CmainService.getMain(id)
        .then((response) => {
          this.dataext = response.data.data;
        })
        .finally(() => (this.loading = false));
    },

    closeView() {
      this.$router.push({ name: "cmainIndex" });
    },
  },
  created() {
    this.getData();
  },
};
</script>

<style scoped></style>
